var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWalletIconActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.20001 5.6002C3.20001 4.27437 4.27418 3.2002 5.60001 3.2002H17.6C18.0418 3.2002 18.4 3.55837 18.4 4.0002C18.4 4.44202 18.0418 4.8002 17.6 4.8002H5.60001C5.15784 4.8002 4.80001 5.15802 4.80001 5.6002C4.80001 6.04237 5.15784 6.4002 5.60001 6.4002H12.8C13.2418 6.4002 13.6 6.75837 13.6 7.2002C13.6 7.64202 13.2418 8.0002 12.8 8.0002H5.60001C4.27418 8.0002 3.20001 6.92602 3.20001 5.6002Z",
    fill: "#22428F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2 6.39961H4.80001L3.20001 5.59961V18.3996C3.20001 19.7252 4.27441 20.7996 5.60001 20.7996H19.2C20.084 20.7996 20.8 20.0836 20.8 19.1996V7.99961C20.8 7.11561 20.084 6.39961 19.2 6.39961ZM17.6 15.1996C16.716 15.1996 16 14.4836 16 13.5996C16 12.7156 16.716 11.9996 17.6 11.9996C18.484 11.9996 19.2 12.7156 19.2 13.5996C19.2 14.4836 18.484 15.1996 17.6 15.1996Z",
    fill: "#22428F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6 15.2C16.716 15.2 16 14.484 16 13.6C16 12.716 16.716 12 17.6 12C18.484 12 19.2 12.716 19.2 13.6C19.2 14.484 18.484 15.2 17.6 15.2Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletIconActive);
export default __webpack_public_path__ + "static/media/wallet-icon-active.7177171e3e3d8820229bcd4166e09e81.svg";
export { ForwardRef as ReactComponent };